import { FileItem } from 'domains/workspaceDetailDomain';
import { useCallback, useRef } from 'react';

export function useDefaultFileList(defaultFileList: FileItem[]) {
  const cache = useRef<{ [index: string]: FileItem[] }>({});

  return useCallback(
    (skuId?: number) => {
      if (cache.current[skuId || 0]) {
        return cache.current[skuId || 0];
      } else {
        const list = (defaultFileList || []).filter(
          (item) => item.skuId === skuId || (!item.skuId && !skuId)
        );

        cache.current[skuId || 0] = list;

        return list;
      }
    },
    [defaultFileList]
  );
}
